exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".searchbox.sbx-google {\n  width: 100%;\n  margin-bottom: 15px;\n}\n.el-input-group__append .vue-instant__suggestions {\n  width: auto;\n}", ""]);

// exports
